/**
 * Created by xiaomo on 2021/4/7.
 */
import RouterView from "./RouterView.vue";
const routes = [
  {
    path: "/welcome",
    name: "Welcome",
    meta: {
      title: "首页",
      icon: "el-icon-notebook-2",
      authCode: false,
      key: "welcome",
    },
    component: () => import("../views/home/welcome.vue"),
  },
  {
    path: "/home",
    name: "homeIndex",
    meta: {
      title: "首页",
      icon: "el-icon-notebook-2",
      authCode: "sa_statics_home",
      key: "home",
    },
    component: () => import("../views/home/index.vue"),
  },
  {
    path: "/evaluation/list", //问卷统计
    name: "EvaluationList",
    component: RouterView,
    meta: {
      title: "问卷统计",
      icon: "el-icon-notebook-2",
      authCode: "sa_statics_home", //sa-evaluation-list
      key: "EvaluationList",
    },
    component: () => import("../views/evaluation/list.vue"),
  },
  {
    path: "/user/doc", //用户详情只有个人权限时展示
    name: "UserHealthInfo",
    component: RouterView,
    meta: {
      title: "健康档案",
      icon: "el-icon-notebook-2",
      authCode: true,
      key: "userDocInfo",
    },
    component: () => import("../views/userManagement/userDoc.vue"),
    children: [
      {
        path: "/user/doc/health-info",
        name: "健康档案D",
        meta: {
          title: "健康档案",
          authCode: false,
          key: "userDocInfo",
        },
        component: () =>
          import("../views/userManagement/health/HealthAssessment.vue"),
      },
      {
        path: "/user/doc/healthHvalue",
        name: "健康值信息D",
        meta: {
          title: "健康值",
          authCode: false,
          key: "userDocInfo",
        },
        component: () =>
          import("../views/userManagement/health/health-hvalue.vue"),
      },
      {
        path: "/user/doc/healthRiskFactor",
        name: "风险因素D",
        meta: {
          title: "风险因素",
          authCode: false,
          key: "userDocInfo",
        },
        component: () =>
          import("../views/userManagement/health/health-risk-factor.vue"),
      },
      {
        path: "/user/doc/health-riskAssessment",
        name: "风险评估D",
        meta: {
          title: "风险评估",
          authCode: false,
          key: "userDocInfo",
        },
        component: () =>
          import("../views/userManagement/health/health-risk-assessment.vue"),
      },
      {
        path: "/user/doc/health-anomalyIndex",
        name: "异常指标D",
        meta: {
          title: "异常指标",
          authCode: false,
          key: "userDocInfo",
        },
        component: () =>
          import("../views/userManagement/health/health-anomalyIndex.vue"),
      },
      {
        path: "/user/doc/health-reportbody",
        name: "体检基础信息D",
        meta: {
          title: "体检基础信息",
          authCode: false,
          key: "userDocInfo",
        },
        component: () =>
          import("../views/userManagement/components/ReportInfo.vue"),
      },
      {
        path: "/user/doc/health-reportList",
        name: "体检信息列表D",
        meta: {
          title: "体检信息列表",
          authCode: false,
          key: "userDocInfo",
        },
        component: () =>
          import("../views/userManagement/health/health-reportList.vue"),
      },
    ],
  },
  {
    path: "/demo",
    name: "Demo",
    meta: {
      title: "一级菜单",
      icon: "el-icon-notebook-2",
      authCode: false,
      key: "demo",
    },
    component: RouterView,
    children: [
      {
        path: "/demo/test_1",
        name: "Demo_1",
        meta: {
          title: "二级菜单",
          authCode: true,
          key: "demo_",
        },
        component: RouterView,
        children: [
          {
            path: "/demo/test_1/test_1_1",
            name: "Demo_1_1",
            meta: {
              title: "三级菜单-1",
              authCode: "sa_admin_save",
              key: "demo_1_1",
            },
            component: () => import("../views/productManage/index.vue"),
          },
          {
            path: "/demo/test_1/test_1_2",
            name: "Demo_1_2",
            meta: {
              title: "三级菜单-2",
              authCode: true,
              key: "demo_1_2",
            },
            component: () => import("../views/productManage/index.vue"),
          },
        ],
      },
      {
        path: "/demo/test_2",
        name: "Demo_2",
        meta: {
          title: "二级菜单-2",
          authCode: true,
          key: "demo_2",
        },
        component: RouterView,
        children: [
          {
            path: "/demo/test_1/test_1_1",
            name: "Demo_2_1",
            meta: {
              title: "三级菜单-2-1",
              authCode: "sa_admin_save",
              key: "demo_2_1",
            },
            component: () => import("../views/productManage/index.vue"),
          },
          {
            path: "/demo/test_1/test_1_2",
            name: "Demo_2_2",
            meta: {
              title: "三级菜单-2-2",
              authCode: true,
              key: "demo_2_2",
            },
            component: () => import("../views/productManage/index.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/product",
    name: "Product",
    meta: {
      title: "产品管理",
      icon: "el-icon-notebook-2",
      authCode: false,
      key: "product",
    },
    component: () => import("../views/productManage/index.vue"),
  },
  {
    path: "/body-report",
    name: "BodyReport",
    component: RouterView,
    meta: {
      title: "体检报告",
      icon: "el-icon-notebook-2",
      authCode: "sa_exam_report",
      key: "bodyReport",
    },
    children: [
      {
        path: "/body-report/query",
        name: "BodyReportQuery",
        meta: {
          title: "体检报告查询",
          authCode: "sa_exam_report_page",
          keepAlive: true,
          key: "bodyReportQuery",
        },
        component: () => import("../views/bodyReport/query.vue"),
      },
      {
        path: "/body-report/detail",
        name: "ReportDetail",
        meta: {
          title: "体检报告详情",
          authCode: false,
          key: "bodyReportQuery",
        },
        component: () => import("../views/bodyReport/reportDetail.vue"),
      },
      {
        path: "/body-report/examine",
        name: "BodyReportExamine",
        meta: {
          title: "体检报告审核",
          authCode: "sa_exam_check_page",
          key: "bodyReportExamine",
        },
        component: () => import("../views/bodyReport/examine.vue"),
      },
      {
        path: "/body-report/import",
        name: "BodyReportImport",
        meta: {
          title: "体检报告导入",
          authCode: "sa_exam_report_import",
          key: "bodyReportImport",
        },
        component: () => import("../views/bodyReport/reportImport.vue"),
      },
    ],
  },
  {
    path: "/user",
    name: "user",
    meta: {
      title: "用户管理",
      icon: "el-icon-notebook-2",
      authCode: "sa_user",
      key: "user",
    },
    component: RouterView,
    children: [
      {
        path: "/user/user-management",
        name: "userManagement",
        meta: {
          title: "用户档案",
          authCode: "sa_user_page",
          key: "userManagement",
        },
        component: () => import("../views/userManagement/index.vue"),
      },
      {
        path: "/user/detail",
        name: "userDetail",
        meta: {
          title: "用户档案详情",
          authCode: false,
          key: "userManagement",
        },
        component: () => import("../views/userManagement/userDetail.vue"),
        children: [
          {
            path: "/user/health-info",
            name: "健康档案",
            meta: {
              title: "健康档案",
              authCode: false,
              key: "userManagement",
            },
            component: () =>
              import("../views/userManagement/health/HealthAssessment.vue"),
          },
          {
            path: "/user/healthHvalue",
            name: "健康值信息",
            meta: {
              title: "健康值",
              authCode: false,
              key: "userManagement",
            },
            component: () =>
              import("../views/userManagement/health/health-hvalue.vue"),
          },
          {
            path: "/user/healthRiskFactor",
            name: "风险因素",
            meta: {
              title: "风险因素",
              authCode: false,
              key: "userManagement",
            },
            component: () =>
              import("../views/userManagement/health/health-risk-factor.vue"),
          },
          {
            path: "/user/health-riskAssessment",
            name: "风险评估",
            meta: {
              title: "风险评估",
              authCode: false,
              key: "userManagement",
            },
            component: () =>
              import(
                "../views/userManagement/health/health-risk-assessment.vue"
              ),
          },
          {
            path: "/user/health-anomalyIndex",
            name: "异常指标",
            meta: {
              title: "异常指标",
              authCode: false,
              key: "userManagement",
            },
            component: () =>
              import("../views/userManagement/health/health-anomalyIndex.vue"),
          },
          {
            path: "/user/health-reportbody",
            name: "体检基础信息",
            meta: {
              title: "体检基础信息",
              authCode: false,
              key: "userManagement",
            },
            component: () =>
              import("../views/userManagement/components/ReportInfo.vue"),
          },
          {
            path: "/user/health-reportList",
            name: "体检信息列表",
            meta: {
              title: "体检信息列表",
              authCode: false,
              key: "userManagement",
            },
            component: () =>
              import("../views/userManagement/health/health-reportList.vue"),
          },
        ],
      },
      {
        path: "/user/detail-abnormal",
        name: "detailAbnormal",
        meta: {
          title: "异常指标解读",
          authCode: false,
          key: "detailAbnormal",
        },
        component: () => import("../views/userManagement/detailAbnormal.vue"),
      },
      {
        path: "/user/detail-examination",
        name: "detailExamination",
        meta: {
          title: "体检服务记录",
          authCode: false,
          key: "detailExamination",
        },
        component: () =>
          import("../views/userManagement/detailExamination.vue"),
      },
      {
        path: "/equityCenter/userEquity",
        name: "userEquity",
        meta: {
          title: "用户权益",
          authCode: "sa_equity_center_user",
          key: "userEquity",
        },
        component: () => import("@/views/equityCenter/userEquity.vue"),
      },
    ],
  },
  {
    path: "/supplier",
    name: "Supplier",
    component: RouterView,
    meta: {
      title: "供应商",
      icon: "el-icon-notebook-2",
      authCode: "sa_provider",
      key: "supplier",
      hideMenu: false,
    },
    children: [
      {
        path: "/supplier/manager",
        name: "SupplierManager",
        meta: {
          title: "供应商管理",
          authCode: "sa_provider_page",
          keepAlive: true,
          key: "supplierManager",
        },
        component: () => import("@/views/supplier/SupplierManager.vue"),
      },
      {
        path: "/supplier/evaluate",
        name: "supplierEvaluate",
        meta: {
          title: "供应商评价",
          authCode: "sa_provider_rate",
          key: "supplierEvaluate",
        },
        component: () => import("../views/supplier/SupplierEvaluate.vue"),
      },
      {
        // 从供应商列表行进入（需 query.id/providerAbbr），非独立侧栏菜单
        path: "/supplier/website-manager",
        name: "WebsiteManager",
        meta: {
          title: "网点管理",
          authCode: false,
          key: "supplierManager",
        },
        component: () => import("@/views/supplier/WebsiteManager.vue"),
      },
      {
        // 从供应商列表行进入（需 query.id/providerAbbr），非独立侧栏菜单
        path: "/supplier/service-manager",
        name: "ServiceManager",
        meta: {
          title: "服务管理",
          authCode: false,
          key: "supplierManager",
        },
        component: () => import("@/views/supplier/ServiceManager.vue"),
      },
    ],
  },
  {
    path: "/service-items",
    name: "service",
    meta: {
      title: "服务项目",
      icon: "el-icon-notebook-2",
      authCode: "sa_item",
      key: "service",
      hideMenu: false,
    },
    component: RouterView,
    children: [
      {
        path: "/service-items/index",
        name: "serviceItems",
        meta: {
          title: "服务项目管理",
          authCode: "sa_item_page",
          key: "serviceItems",
        },
        component: () => import("../views/serviceItems/index.vue"),
      },
      {
        path: "/service-items/service-items-add",
        name: "serviceItemsAdd",
        meta: {
          title: "新增",
          authCode: false,
          key: "serviceItems",
        },
        component: () => import("../views/serviceItems/detail.vue"),
      },
      {
        path: "/service-items/service-items-detail",
        name: "serviceItemsDetail",
        meta: {
          title: "查看",
          authCode: false,
          key: "serviceItems",
        },
        component: () => import("../views/serviceItems/detail.vue"),
      },
      {
        path: "/service-items/service-items-edit",
        name: "serviceItemsEdit",
        meta: {
          title: "编辑",
          authCode: false,
          key: "serviceItems",
        },
        component: () => import("../views/serviceItems/detail.vue"),
      },
      {
        path: "/service-items/rights-card",
        name: "rightsCard",
        meta: {
          title: "权益卡管理",
          authCode: "sa_rights_card_page",
          key: "rightsCard",
        },
        component: () => import("../views/rightsCard/index.vue"),
      },
      {
        path: "/service-items/rights-card-add",
        name: "rightsCardAdd",
        meta: {
          title: "新增",
          authCode: false,
          key: "rightsCard",
        },
        component: () => import("../views/rightsCard/detail.vue"),
      },
      {
        path: "/service-items/rights-card-edit",
        name: "rightsCardEdit",
        meta: {
          title: "编辑",
          authCode: false,
          key: "rightsCard",
        },
        component: () => import("../views/rightsCard/detail.vue"),
      },
      {
        path: "/service-items/rights-card-whitelist",
        name: "rightsCardWhitelist",
        meta: {
          title: "白名单管理",
          authCode: false,
          key: "rightsCard",
        },
        component: () => import("../views/rightsCard/whitelist.vue"),
      },
      {
        path: "/service-items/rights-card-whitelist-add",
        name: "rightsCardWhitelistAdd",
        meta: {
          title: "新增",
          authCode: false,
          key: "rightsCard",
        },
        component: () => import("../views/rightsCard/whitelistAdd.vue"),
      },
      {
        path: "/service-items/rights-card-code",
        name: "rightsCardCode",
        meta: {
          title: "卡密管理",
          authCode: false,
          key: "rightsCard",
        },
        component: () => import("../views/rightsCard/code.vue"),
      },
    ],
  },
  {
    path: "/service-order",
    name: "ServiceOrder",
    component: RouterView,
    meta: {
      title: "服务订单",
      icon: "el-icon-notebook-2",
      authCode: "sa_order",
      key: "serviceOrder",
    },
    children: [
      {
        path: "/service-order/physical",
        name: "ServiceOrderPhysical",
        meta: {
          title: "核保体检",
          authCode: "sa_physical_order",
          key: "serviceOrderPhysical",
        },
        component: () => import("../views/serviceOrder/physical.vue"),
      },
      {
        path: "/service-order/healthy",
        name: "ServiceOrderHealthy",
        meta: {
          title: "健康体检",
          authCode: "sa_medical_order",
          key: "serviceOrderHealthy",
        },
        component: () => import("../views/serviceOrder/healthy.vue"),
      },
      {
        path: "/service-order/healthyDetail",
        name: "ServiceOrderHealthyDetail",
        meta: {
          title: "健康体检详情",
          authCode: false,
          key: "serviceOrderHealthyhealthy",
        },
        component: () => import("../views/serviceOrder/healthyDetail.vue"),
      },
      {
        path: "/service-order/telephoneDoctor",
        name: "ServiceOrderTelephoneDoctor",
        meta: {
          title: "电话医生",
          authCode: "sa_call_doctor_order",
          key: "serviceOrderTelephoneDoctor",
        },
        component: () => import("../views/serviceOrder/telephoneDoctor.vue"),
      },
      {
        path: "/service-order/videoDoctor",
        name: "ServiceOrderVideoDoctor",
        meta: {
          title: "视频医生",
          authCode: "sa_video_doctor_order",
          key: "serviceOrderVideoDoctor",
        },
        component: () => import("../views/serviceOrder/videoDoctor.vue"),
      },
      {
        path: "/service-order/expertAppointment",
        name: "ServiceOrderExpertAppointment",
        meta: {
          title: "专家预约",
          authCode: "sa_expert_appointment_order",
          key: "serviceOrderExpertAppointment",
        },
        component: () => import("../views/serviceOrder/expertAppointment.vue"),
      },
      {
        path: "/service-order/expertSurgery",
        name: "ServiceOrderExpertSurgery",
        meta: {
          title: "专家手术",
          authCode: "sa_expert_surgery_order",
          key: "serviceOrderExpertSurgery",
        },
        component: () => import("../views/serviceOrder/expertSurgery.vue"),
      },
      {
        path: "/service-order/expertWard",
        name: "ServiceOrderExpertWard",
        meta: {
          title: "专家病房",
          authCode: "sa_expert_ward_order",
          key: "serviceOrderExpertWard",
        },
        component: () => import("../views/serviceOrder/expertWard.vue"),
      },
      {
        path: "/service-order/evacount",
        name: "evacount",
        meta: {
          title: "健康评估记录",
          authCode: "sa_evacount_order",
          key: "evacount",
        },
        component: () => import("../views/serviceOrder/evacount.vue"),
      },
      {
        path: "/service-order/hospitalPay",
        name: "ServiceOrderHospitalPay",
        meta: {
          title: "住院垫付",
          authCode: true,
          key: "serviceOrderHospitalPay",
        },
        component: () => import("../views/serviceOrder/hospitalPay.vue"),
      },
      {
        path: "/service-order/doctorHelp",
        name: "ServiceOrderDoctorHelp",
        meta: {
          title: "就医指导",
          authCode: true,
          key: "serviceOrderDoctorHelp",
        },
        component: () => import("../views/serviceOrder/doctorHelp.vue"),
      },
    ],
  },
  {
    path: "/reportCenter",
    name: "reportCenter",
    component: RouterView,
    meta: {
      title: "报表中心",
      icon: "el-icon-notebook-2",
      authCode: "sa_report_form",
      key: "reportCenter",
      hideMenu: false,
    },
    children: [
      {
        path: "/reportCenter/supervise",
        name: "reportCenterSupervise",
        meta: {
          title: "监管报表",
          authCode: "sa_report_form_supervise",
          key: "reportCenterSupervise",
        },
        component: () => import("../views/reportCenter/supervise.vue"),
      },

      {
        path: "/reportCenter/financial",
        name: "reportCenterFinancial",
        meta: {
          title: "财务报表",
          // authCode: "sa_report_form_financial",
          key: "reportCenterFinancial",
        },
        component: () => import("../views/reportCenter/financial.vue"),
      },

      {
        path: "/reportCenter/customer",
        name: "reportCenterCustomer",
        meta: {
          title: "客户量报表",
          authCode: "sa_report_form_customer",
          key: "reportCenterCustomer",
        },
        component: () => import("../views/reportCenter/customer.vue"),
      },
    ],
  },
  {
    path: "/basicData",
    name: "BasicData",
    component: RouterView,
    meta: {
      title: "服务类型管理",
      icon: "el-icon-notebook-2",
      authCode: "sa_service_type",
      key: "basicData",
      hideMenu: false,
    },
    children: [
      {
        path: "/basicData/serviceType",
        name: "BasicDataServiceType",
        meta: {
          title: "服务类别管理",
          authCode: "sa_service_type_kind",
          key: "basicDataServiceType",
        },
        component: () => import("../views/basicData/serviceTypeList.vue"),
      },
      {
        path: "/basicData/provisionMode",
        name: "BasicDataProvisionMode",
        meta: {
          title: "服务提供方式",
          authCode: "sa_service_type_mode",
          key: "basicDataProvisionMode",
        },
        component: () => import("../views/basicData/provisionModeList.vue"),
      },
    ],
  },
  {
    path: "/system",
    name: "System",
    component: RouterView,
    meta: {
      title: "系统管理",
      icon: "el-icon-notebook-2",
      // authCode: "sa_system_menu",
      authCode: "sa_system_manage",
      key: "system",
    },
    children: [
      {
        path: "/config/channel",
        name: "ConfigChannel",
        meta: {
          title: "渠道配置",
          authCode: "sa_config_channel",
          key: "configChannel",
        },
        component: () => import("../views/channelManage/channel.vue"),
      },
      {
        path: "/system/log",
        name: "SystemLog",
        meta: {
          title: "系统日志",
          authCode: "sa_operate_log_index",
          key: "systemLog",
        },
        component: () => import("../views/systemManage/log.vue"),
      },
      {
        path: "/system/user",
        name: "SystemUser",
        meta: {
          title: "用户管理",
          authCode: "sa_admin_menu",
          key: "systemUser",
        },
        component: () => import("../views/systemManage/user.vue"),
      },
      {
        path: "/system/role",
        name: "SystemRole",
        meta: {
          title: "角色管理",
          authCode: "sa_role_menu",
          key: "systemRole",
        },
        component: () => import("../views/systemManage/role.vue"),
      },
      {
        path: "/system/operation",
        name: "SystemOperation",
        meta: {
          title: "操作日志",
          authCode: "sa_operate_log_index",
          key: "systemOperation",
        },
        component: () => import("../views/systemManage/operation.vue"),
      },
      {
        path: "/system/area",
        name: "SystemArea",
        meta: {
          title: "行政区划管理",
          authCode: "sa_area",
          key: "systemArea",
        },
        component: () => import("../views/systemManage/area.vue"),
      },
    ],
  },
];
export default routes;
